import React from 'react';
import { Avatar, Badge } from '@material-ui/core';
import styles from './index.module.scss';
import Moment from 'react-moment';

const ResourceItem = (props: any) => {
    const { isActive, item } = props;

    const onClickItem = () => {
        props.onClick();
    };

    return (
        <div className={styles.container + `${isActive ? ' active' : ''}`} onClick={onClickItem}>
            <Badge overlap="circle"
                         anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                         }}
                         variant="dot">
                <Avatar className={styles.avatar}>{item.initial}</Avatar>
            </Badge>

            <div className={styles.content}>
                <div className={styles.header}>
                    <div className={styles.title}>
                        {item.name}
                    </div>
                    <div className={styles.meta}>
                        <Moment local format="hh:mm a">
                        {item.datetimestamp}
                        </Moment>
                    </div>
                </div>
                <div className={styles.body}>
                    {item.message}
                </div>
            </div>
        </div>
    );
};

export default ResourceItem;
